import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';
import { hidePolygonOnMap, removeCustomPolygonFromActive } from '@slices/map';

import { deletePolygons } from '@api/map';

import { ESnackbarTypes } from '@enums/common';

import { CUSTOM_POLYGON, DELETE_POLYGON } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateDeletePolygons = (onSuccessCallback?: () => void) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const { isLoading: isDeletingPolygon, mutate: deleteCustomPolygons } = useMutation({
		mutationKey: [DELETE_POLYGON],
		mutationFn: deletePolygons,
		onSuccess: (_, data) => {
			dispatch(setSnackbar({
				message: responseMessages.deletePolygon,
				type: ESnackbarTypes.success,
			}));
			dispatch(removeCustomPolygonFromActive(data as unknown as string));
			dispatch(hidePolygonOnMap(data as unknown as string));

			if (onSuccessCallback) onSuccessCallback();

			return queryClient.invalidateQueries([CUSTOM_POLYGON]);
		},
	});

	return {
		deleteCustomPolygons: deleteCustomPolygons as unknown as UseMutateFunction<any, any, string[], any>,
		isDeletingPolygon,
	};
};
